import { render, staticRenderFns } from "./TaskNewDialogChangeStatus.vue?vue&type=template&id=40f263bd"
import script from "./TaskNewDialogChangeStatus.vue?vue&type=script&lang=js"
export * from "./TaskNewDialogChangeStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports